import { BlogFilter } from "../../../filters/BlogFilter";
import { Client } from "../Client";
import { APIRequest, APIRequestMethod } from "../APIRequest";
import { Blog } from "../../../types/Blog";
import { ListingFilter } from "../../../filters/ListingFilter";

class BlogAPI {
    Search(filter: BlogFilter, embed: boolean = false): Promise<Blog[]> {
        return Client.Request(new APIRequest(APIRequestMethod.POST, '/api/blogs/search', filter).SetEmbed(embed));
    }

    Get(blogId: string, embed: boolean = false): Promise<Blog> {
        return Client.Request(new APIRequest(APIRequestMethod.GET, `/api/blogs/${blogId}`).SetEmbed(embed));
    }

    GetSuburbProfiles(filter: ListingFilter, embed: boolean = true): Promise<Blog[]> {
        return Client.Request(new APIRequest(APIRequestMethod.POST, '/api/blogs/suburb_profiles', filter).SetEmbed(embed));
    }
}

export { BlogAPI }